// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryPrepareIcon from '../../../assets/new_gems/Category/GemCategoryPrepare.svg?inline';
import React from 'react';
export const GemCategoryPrepare = (props)=>{
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: gemCategoryPrepareIcon,
        alt: "GemCategoryPrepareImage"
    });
};
